import type { CSSProperties, SVGProps } from 'react'
import React from 'react'

export const svgIconStyles: CSSProperties = {
  fill: 'currentColor',
  width: '1em',
  height: '1em',
  display: 'inline-block',
  fontSize: '1.2857142857142856rem',
  transition: 'fill 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
  flexShrink: 0,
  userSelect: 'none',
}

/** Plain SVG wrapper with MUI-equivalent default styles. Drop-in replacement for the old MUI styled('svg'). */
export const StyledSvg = (props: SVGProps<SVGSVGElement>) => {
  const { style, ...rest } = props
  return React.createElement('svg', { ...rest, style: { ...svgIconStyles, ...style } })
}
